import { EditorState, Plugin, Transaction } from 'prosemirror-state'

// This plugin makes code marks inclusive on the left, meaning that when the
// cursor is before the code mark we type in the code block. Furthermore
// it sets the internal "mark cursor" to preview that behaviour (otherwise it
// looks like the cursor is outside the code mark.)
export const InclusiveCodeMarks = new Plugin({
  appendTransaction: (transactions: Transaction[], oldState: EditorState, newState: EditorState) => {
    const $from = transactions[0]?.selection.$from
    const empty = transactions[0]?.selection.empty
    if (!$from || !empty) return

    if (
      newState.schema.marks.code.isInSet($from.nodeAfter?.marks || []) &&
      !newState.schema.marks.code.isInSet($from.nodeBefore?.marks || [])
    ) {
      const tr = newState.tr
      tr.addStoredMark(newState.schema.marks.code.create())
      return tr
    }
  },
  view: () => ({
    update: (view) => {
      const {
        state: {
          selection: { $from, empty },
        },
      } = view

      if (!empty) {
        // if we started our selection with a mark cursor and now its empty we
        // need to remove it, or we get a weird mark cursor on the end of our
        // selection
        view.markCursor = null
        return
      }

      if (
        view.state.schema.marks.code.isInSet($from.nodeAfter?.marks || []) &&
        !view.state.schema.marks.code.isInSet($from.nodeBefore?.marks || []) &&
        view.state.selection.$anchor.node(view.state.selection.$anchor.depth).type !==
          view.state.schema.nodes.code_block
      ) {
        view.markCursor = [view.state.schema.marks.code.create()]

        // There's a chrome bug where it won't put the selection into the code
        // block, so we forcefully low-level check that and correct it if it
        // occurs
        const documentSelection = document.getSelection()
        if (documentSelection?.anchorNode?.nodeName !== 'CODE') {
          if (documentSelection?.anchorNode?.nextSibling && documentSelection?.rangeCount > 0) {
            documentSelection.getRangeAt(0).setStart(documentSelection.anchorNode.nextSibling, 1)
          }
        }
      } else {
        // this seems to not interfere with prosemirror's "native" mark
        // cursors, as they seem to be set after this method is called
        view.markCursor = null
      }
    },
  }),
})
